import { TBingoGameSchedule, TGames, TGetBingoScheduleResponse } from './types';

const getClearTime = (time: string) => new Date(`${time}Z`.replace(/ /g, 'T'));

const sortByTime = (a: TBingoGameSchedule, b: TBingoGameSchedule) =>
    Number(getClearTime(a.drawTime)) - Number(getClearTime(b.drawTime));

export const sortBingoSchedule = (response: TGetBingoScheduleResponse): TBingoGameSchedule[] => {
    return response.data.siteSchedules.sort(sortByTime);
};

export const gamesSortingByBingoSchedule = (bingoScheduleData: TBingoGameSchedule[], games: TGames[]) => {
    if (!bingoScheduleData.length) {
        return games;
    }

    const sortingData = bingoScheduleData.map(({ name }) => name);

    return games
        .map((game) => {
            const sortingOrder = sortingData.indexOf(game.gameCode);

            return { ...game, order: sortingOrder !== -1 ? sortingOrder : sortingData.length };
        })
        .sort((gameA, gameB) => gameA.order - gameB.order);
};
